// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__DXoWE","imageIcon":"NotFound_imageIcon__1uSJS","buttonBack":"NotFound_buttonBack__1FDUn"};